import { useQuery } from "@tanstack/react-query"
import { useLoaderData } from "@tanstack/react-router"

import { useQueries } from "@/hooks/useRootContext.ts"
import { isUserPrincipal } from "@/lib/std.ts"

import type {
  CPrincipal,
  ProfileIdentifier,
  TD_MemberProfile,
  TD_MemberProfile_Minimal
} from "@/lib/client/generated/TypeDefinitions.ts"


export const myProfileQueryKey = ["profile", "me"]

export const myPrincipalQueryKey = ["profile", "principal", "me"]

export const agentUsername = "agent"

export function useProfile(username: ProfileIdentifier.Username) {
  const client = useQueries().apiClient
  const mutedUsernames = new Set<string>([agentUsername, "support"])

  return useQuery({
    queryKey: ["profile", username.username],
    queryFn: () => mutedUsernames.has(username.username) ? Promise.resolve(null) : client.profile(username),
    staleTime: Infinity,
    throwOnError: false
  })
}

export function useMyPrincipal(): CPrincipal {
  // Loader data becomes undefined because of the onLeave handler in OrgRoute
  const loaderData = useLoaderData({ from: "/$orgId" }) as {
    principal: CPrincipal
  }

  return loaderData.principal
}

export function useMyProfile(): TD_MemberProfile | null {
  const myPrincipal = useMyPrincipal()

  if (isUserPrincipal(myPrincipal)) {
    return myPrincipal.details.user
  }

  return null
}

export function getFullName(profile: TD_MemberProfile | TD_MemberProfile_Minimal) {
  return [profile.name.firstName, profile.name.lastName].filter(Boolean).join(" ")
}

export function getShortName(profile: TD_MemberProfile | TD_MemberProfile_Minimal) {
  const lastInitial = profile.name.lastName ? `${profile.name.lastName.trim().charAt(0)}.` : ""

  return [profile.name.firstName, lastInitial].filter(Boolean).join(" ")
}
